import script from "./DescrizioneOrdine.vue?vue&type=script&setup=true&lang=js"
export * from "./DescrizioneOrdine.vue?vue&type=script&setup=true&lang=js"

import "./DescrizioneOrdine.vue?vue&type=style&index=0&id=4c2f3bb3&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c2f3bb3"]])

export default __exports__